export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">投稿爆料</h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
            <div className="flex-1">
              <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">你有料，我们有平台</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                吃瓜网51欢迎每一位知情者投稿<strong>爆料</strong>。我们提供完全<strong>匿名投稿</strong>通道，严格保护爆料人隐私。无论你是娱乐圈从业者、知情人士还是热心<strong>吃瓜</strong>群众，只要你有真实可信的<strong>内幕消息</strong>，都可以通过以下方式联系我们。
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-center gap-3 text-sm text-foreground-700">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <span>爆料邮箱：tips@chigua51.com</span>
                </li>
                <li className="flex items-center gap-3 text-sm text-foreground-700">
                  <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-accent-600"></i>
                  </div>
                  <span>微信公众号：吃瓜网51爆料</span>
                </li>
                <li className="flex items-center gap-3 text-sm text-foreground-700">
                  <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-smartphone-line text-secondary-600"></i>
                  </div>
                  <span>APP内直接提交：下载APP使用匿名投稿功能</span>
                </li>
              </ul>
            </div>
            <div className="flex-1 bg-background-50 rounded-xl p-6 border border-background-200/70">
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">投稿须知</h4>
              <ul className="space-y-2.5 text-xs md:text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  请提供尽可能详细的事件信息和相关证据材料
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  我们承诺对所有投稿人信息严格保密
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  稿件采用后将根据爆料价值支付稿酬
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  请勿编造虚假信息，我们会对内容进行核实
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  重大独家爆料请通过加密渠道联系
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}